import React from 'react';

import { TabCtn, SvgCtn, TabText } from './index.style';

interface NavTabProps {
  active?: boolean;
  children?: React.ReactChild;
  text: string;
  handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  hideOnDesktop?: boolean;
  hideOnMobile?: boolean;
}

const NavTab: React.FC<NavTabProps> = ({
  active,
  children,
  handleClick,
  hideOnDesktop,
  hideOnMobile,
  text,
  sub,
}): React.ReactElement => {
  return (
    <TabCtn onClick={handleClick} active={active} hideOnDesktop={hideOnDesktop} hideOnMobile={hideOnMobile} sub={sub}>
      <SvgCtn>{children}</SvgCtn>
      <TabText>{text}</TabText>
    </TabCtn>
  );
};

export default NavTab;
